(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('header', Header)

    /** @ngInject */
    function Header($state, $rootScope, $timeout, $window, AuthenticationService, HelperService, PATHS, DATA_EVENTS) {
        function HeaderController($scope) {
            const vm = this;

            vm.onChangeUnit = () => {
                const currentSelectedUnit = AuthenticationService.getSelectedUnit();

                if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                    AuthenticationService
                        .setUnit(vm.selectedUnit.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            AuthenticationService.configureUserPermissions($state.current);

                            if (response.error)
                                HelperService.handleStateChangeError(response);
                        }, error => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                            AuthenticationService.configureUserPermissions($state.current);

                            HelperService.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleMenu = () => {
                $rootScope.menuOpen = !$rootScope.menuOpen;
            }

            vm.toggleSelectUnit = () => {
                $rootScope.showSelectUnit = !$rootScope.showSelectUnit;
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                vm.modules = [];

                init();
            })

            angular.element($window).on('resize', () => {
                $rootScope.isMobile = HelperService.isScreenSmaller(991);

                $timeout(() => {
                    vm.isMobile = $rootScope.isMobile;
                });
            });

            $scope.$on('$destroy', () => {
                removeWatchUnit();
                angular.element($window).unbind('resize');
            })

            init();

            function init() {
                const authSelectedUnit = AuthenticationService.getSelectedUnit();
                const userData = AuthenticationService.getUserData();

                vm.logout = AuthenticationService.logout;
                vm.units = AuthenticationService.getUnits();
                vm.isMobile = $rootScope.isMobile;
                vm.unitsDisabled = userData.IsInOpeningProcess && !vm.units.length;

                let foundUnit = vm.units.find(unit => (unit.Id == authSelectedUnit.Id));

                if (foundUnit)
                    vm.selectedUnit = foundUnit;

                vm.isMobile = HelperService.isScreenSmaller(991);
                $rootScope.menuOpen = vm.menuOpen;
            }
        }

        return {
            bindToController: true,
            controller: HeaderController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`,
            scope: {}
        }
    }
}());